/**
 * Creation tool step.
 */
enum CreationToolStep {
    VideoTrim = 'CT_STEP_VIDEO_TRIM',
    CutOut = 'CT_STEP_CUT_OUT',
    Animate = 'CT_STEP_ANIMATE',
    Decorate = 'CT_STEP_DECORATE',
    Upload = 'CT_STEP_UPLOAD',
}

namespace CreationToolStep {
    /**
     * Returns the step's route url.
     */
    export function route(step: CreationToolStep): string {
        switch (step) {
            case CreationToolStep.VideoTrim:
                return `/video-trim`
            case CreationToolStep.CutOut:
                return `/cut-out`
            case CreationToolStep.Animate:
                return `/animate`
            case CreationToolStep.Decorate:
                return `/decorate/caption`
            case CreationToolStep.Upload:
                return `/finalize`
        }
    }

    /**
     * Returns the step's breadcrumb label.
     */
    export function label(step: CreationToolStep): string {
        switch (step) {
            case CreationToolStep.VideoTrim:
                return 'Trim'
            case CreationToolStep.CutOut:
                return 'Cut Out'
            case CreationToolStep.Animate:
                return 'Animate'
            case CreationToolStep.Decorate:
                return 'Decorate'
            case CreationToolStep.Upload:
                return 'Upload'
        }
    }

    /**
     * Returns the step's display title.
     */
    export function title(step: CreationToolStep): string {
        switch (step) {
            case CreationToolStep.VideoTrim:
                return 'Trim Your Video'
            case CreationToolStep.CutOut:
                return 'Cut it Out'
            case CreationToolStep.Animate:
                return 'Bring it to Life'
            case CreationToolStep.Decorate:
                return ''
            case CreationToolStep.Upload:
                return 'Add Info'
        }
    }

    /**
     * Returns the step's description text.
     */
    export function description(step: CreationToolStep): string {
        switch (step) {
            case CreationToolStep.VideoTrim:
                return `Use the sliders to adjust the length & segment of your video. The shorter your video is, the quicker we'll be able to process your file!`
            case CreationToolStep.CutOut:
                return 'Use our sticker tools to create an outline of your sticker & remove the background.'
            case CreationToolStep.Animate:
                return 'Choose a motion filter below to make your sticker move.'
            case CreationToolStep.Decorate:
            case CreationToolStep.Upload:
                return ''
        }
    }
}

export default CreationToolStep
